import { z } from 'zod'

export const zRule = () =>
  z.object({
    compoundId: z.number(),
    name: z.string(),
    type: z.string(),
    value: z.string().or(z.number()).nullable(),
    module: z.string().nullable()
  })

export type Rule = z.infer<ReturnType<typeof zRule>>

export const zRules = () => z.array(zRule())
export type Rules = z.infer<ReturnType<typeof zRules>>
